// extracted by mini-css-extract-plugin
export default {"PharmacyDetailsPriceCard":"vhaktOqK","PharmacyDetailsPriceCardHeader":"jJnVDrZE","PharmacyDetailsPriceCardPrice":"iFwrT7rh","PharmacyDetailsPriceCardWhitelabel":"f57I2alC"};